import React, { useState } from 'react';

interface IContextState {
  content: JSX.Element | null;
  setContent: (content: JSX.Element | null) => void;
}

export const HeaderContext = React.createContext({} as IContextState);

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const HeaderContextProvider = (props: any) => {
  const [content, setContent] = useState<JSX.Element | null>(null);

  return <HeaderContext.Provider value={{ content, setContent }}>{props.children}</HeaderContext.Provider>;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default HeaderContextProvider;
